import React, { ReactNode } from "react";
import { useHistory } from "react-router-dom";
import BackAction from "../Common/BackAction";

interface AuthLayoutProps {
  children: ReactNode;
  backActionRoute?: string;
}

const AuthLayout = ({ children, backActionRoute }: AuthLayoutProps) => {
  const history = useHistory();
  return (
    <div className="bwp-auth-layout">
      {backActionRoute &&
        <div className="bwp-auth-layout__back">
          <BackAction onClick={() => history.push(backActionRoute)} />
        </div>
      }
      <div className="bwp-auth-layout__stack">{children}</div>
    </div>
  )
}

export default AuthLayout;